/**
 * Registro de uso das telas no e360 (JOR4-7826).
 *
 * Ponto único de envio: toda tela registra por aqui, e é aqui que mora o
 * contrato com quem chama. O registro é disparado e esquecido — não se espera
 * a resposta e o erro não propaga (RN05). O e360 é um serviço à parte e pode
 * estar fora do ar ou recusar a sessão (a de embarcador não tem empresa no
 * token); nada disso pode atrasar ou quebrar a ação que o usuário acabou de
 * fazer.
 *
 * `tela` sozinha é o acesso à tela; com `funcao`, uma ação dentro dela. As
 * telas vêm do catálogo `TELAS`: o nome é fixo e o que varia vai no código.
 *
 * Quando chamar: a função que abre um popup registra depois de exibi-lo; a
 * que grava, depois do sucesso. Cancelar uma confirmação, parar num aviso
 * antes de abrir ou ter a gravação recusada não é uso da função.
 */

import { enviarAcessoE360 } from "./api";
import type { ItemRastreado } from "./telas";

/** Sem a URL do e360 no ambiente não há para onde enviar. */
const e360Configurado = () => Boolean(process.env.API_E360_INTEGRACAO_URL);

export const registrarUso = (
    tela: ItemRastreado,
    funcao?: ItemRastreado,
): void => {
    if (!e360Configurado()) return;

    enviarAcessoE360(tela, funcao).catch((erro) => {
        const codigo = funcao ? `${tela.codigo} › ${funcao.codigo}` : tela.codigo;
        console.warn("Falha ao registrar uso no e360", codigo, erro);
    });
};
